import * as act from 'app/actions';

export const GET_PLANS_VALIDATION = 'validation-plans/GET_PLANS_VALIDATION';

export const getPlansValidation = (payload) => act.action(GET_PLANS_VALIDATION, { payload });
